module.exports = __webpack_public_path__ + "static/media/lvl-group-4.196e18ec.png";